import { render, staticRenderFns } from "./Pickban.vue?vue&type=template&id=3dce1c3e&scoped=true"
import script from "./Pickban.vue?vue&type=script&lang=js"
export * from "./Pickban.vue?vue&type=script&lang=js"
import style0 from "./Pickban.vue?vue&type=style&index=0&id=3dce1c3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dce1c3e",
  null
  
)

export default component.exports